import { getType } from 'typesafe-actions'
import { Reducer } from 'redux'
import { PageAction, setGeografi, setPageNotFound, setParti } from '../actions/page'
import { PageState } from '../state'

type PageReducer = Reducer<PageState, PageAction>

export const defaultPage: PageState = { current: 'PAGE_NOT_FOUND' }

export const pageReducer: PageReducer = (currentState = defaultPage, action) => {
  switch (action.type) {
    case getType(setGeografi):
      return { ...currentState, current: action.payload }
    case getType(setParti):
      return { ...currentState, current: action.payload }
    case getType(setPageNotFound):
      return { ...currentState, current: 'PAGE_NOT_FOUND' }
    default:
      return currentState
  }
}
